export const Spacer = ({ height = 15 }) => (
  <div style={{ height: `${height}px`, width: '100%' }} />
);